import {
  DEFAULT_GOOGLE_LOCATION,
  InvoiceExtractionSettings,
  InvoiceExtractionSettingsFormValues,
} from "services/api/settings/invoiceExtraction/types";

/**
 * Početne vrijednosti obrasca iz spremljenih postavki. Ključ servisnog računa se ne vraća s
 * poslužitelja, pa polje uvijek kreće prazno — prazno znači „ostavi postojeći".
 */
export const getFormValues = (
  settings: InvoiceExtractionSettings
): InvoiceExtractionSettingsFormValues => ({
  pipeline: settings.pipeline,
  model: settings.model,
  ocrModel: settings.ocrModel,
  prompt: settings.prompt,
  googleProjectId: settings.googleProjectId,
  googleProcessorId: settings.googleProcessorId,
  googleLocation: settings.googleLocation || DEFAULT_GOOGLE_LOCATION,
  googleCredentialsJson: "",
});
